import React, { Component } from 'react';
import { O2oaPath } from '@/utils/utils';
import Container from "@/components/Container";
import Iframe from '@/components/Iframe';

export default class InstructionsForFunding extends Component {

  render () {
    const IframeDom = Iframe({
      src: `${O2oaPath.pathParams}h5%26page%3DreviewProcess%26processAppId%3Dab1cddc8-a9f9-4a9e-ab73-13646b195ae2%26processId%3D2d18f743-e8b6-43e5-a653-15fb960c8145`,
    });

    return (<Container breStates>
      <IframeDom />
    </Container>);
  }
}
